import { CdkDrag, CdkDragDrop, CdkDragHandle, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TopicLevel3SelectorComponent } from '@examdojo/category/v2';
import { ButtonComponent } from '@examdojo/core/button';
import { IconButtonComponent } from '@examdojo/core/icon-button';
import { QuestionEditingOptions } from '@examdojo/models/question-editor';
import { ContentItemEditorComponent, ContentItemFormGroup } from '@examdojo/question-content-item';
import { provideQuestionImageBucketName } from '@examdojo/question-image';
import { NumberInputComponent, TextInputComponent } from '@examdojo/ui/input';
import { MultiLineTextComponent } from '@examdojo/ui/multi-line-text';
import {
  ActiveMarkschemeEditorSubItemCoordinates,
  MARKSCHEME_ITEM_TYPE_TO_LONG_LABEL,
  MarkschemeEditorItemEnum,
} from '../markscheme-item.model';
import { createMarkGroupNoteFormControl, MarkGroupFormGroup } from './markscheme-markgroup-editor.model';

@Component({
  selector: 'dojo-markscheme-markgroup-editor',
  templateUrl: './markscheme-markgroup-editor.component.html',
  providers: [provideQuestionImageBucketName('markscheme-images')],
  imports: [
    TextInputComponent,
    NumberInputComponent,
    MatTooltipModule,
    IconButtonComponent,
    ContentItemEditorComponent,
    ButtonComponent,
    TitleCasePipe,
    TopicLevel3SelectorComponent,
    MultiLineTextComponent,
    CdkDropList,
    CdkDrag,
    CdkDragHandle,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarkschemeMarkgroupEditorComponent {
  readonly solutionPathsCountFC = input.required<FormControl<string>>();
  readonly formCtrl = input.required<MarkGroupFormGroup>();
  readonly editingOptions = input.required<QuestionEditingOptions>();

  readonly editItem = output<{ item: ContentItemFormGroup; coordinates: ActiveMarkschemeEditorSubItemCoordinates }>();
  readonly MarkschemeEditorItemEnum = MarkschemeEditorItemEnum;
  readonly MARKSCHEME_ITEM_TYPE_TO_LONG_LABEL = MARKSCHEME_ITEM_TYPE_TO_LONG_LABEL;

  readonly shouldShowMetadata = computed(() => !this.editingOptions().hideMarkschemeMetadata);

  addNote() {
    this.formCtrl().controls.notes.push(createMarkGroupNoteFormControl());
    this.formCtrl().controls.notes.markAsDirty();
    this.formCtrl().controls.notes.markAsTouched();
  }

  removeNote(index: number) {
    this.formCtrl().controls.notes.removeAt(index);
    this.formCtrl().controls.notes.markAsDirty();
    this.formCtrl().controls.notes.markAsTouched();
  }

  dropNote(event: CdkDragDrop<FormArray<FormControl<string>>>) {
    moveItemInArray(this.formCtrl().controls.notes.controls, event.previousIndex, event.currentIndex);
    this.formCtrl().controls.notes.markAsDirty();
    this.formCtrl().controls.notes.markAsTouched();
    this.formCtrl().controls.notes.updateValueAndValidity();
  }

  editMarkgroupItem({ item, contentItemIndex }: { item: ContentItemFormGroup; contentItemIndex: number }) {
    this.editItem.emit({ item, coordinates: { criterion: contentItemIndex } });
  }
}
